import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsData from './GetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsData';
import deleteOrgUnitAthleteEntryOrgUnitNonAthleteEntryData from './DeleteOrgUnitAthleteEntryOrgUnitNonAthleteEntryData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData = {
  INITIAL_STATE, getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsData, deleteOrgUnitAthleteEntryOrgUnitNonAthleteEntryData
};

export default OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData;